
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.504 8.842l-1.62 1.62a.422.422 0 01-.598 0L14.383 6.56a.422.422 0 010-.598l1.621-1.62a1.691 1.691 0 012.387 0l2.113 2.113c.661.657.661 1.726 0 2.387zm-7.513-1.487l-9.232 9.232-.746 4.272a.845.845 0 00.978.977l4.271-.749 9.233-9.232a.422.422 0 000-.598l-3.903-3.902a.427.427 0 00-.601 0zm-5.629 8.441a.49.49 0 010-.696l5.415-5.414a.49.49 0 01.696 0 .49.49 0 010 .696l-5.415 5.414a.49.49 0 01-.696 0zm-1.269 2.957h1.688v1.276l-2.268.397-1.093-1.093.397-2.268h1.276v1.688z","fill":"#191F2D"}})])
          )
        }
      }
    